<template>

  <svg
    t="1640064809936"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4062"
    width="64"
    height="64"
  ><path d="M904.53333333 129.06666667H119.46666667c-18.8512 0-34.13333333 15.27786667-34.13333334 34.1248a34.11946667 34.11946667 0 0 0 10.00106667 24.13333333l302.93226667 302.74773333v418.736c0 18.84693333 15.28213333 34.1248 34.13333333 34.1248a34.1408 34.1408 0 0 0 16.51413333-4.2592l170.61546667-94.2912a34.12266667 34.12266667 0 0 0 17.62133333-29.86453333l-0.00213333-327.25226667L929.01333333 186.97173333c13.13706667-13.5168 12.82666667-35.12106667-0.69333333-48.25493333A34.1376 34.1376 0 0 0 904.53333333 129.06666667z m-702.64106666 68.24853333h621.88053333l-245.23733333 252.32213333a34.11946667 34.11946667 0 0 0-9.65226667 23.78026667v320.9728l-102.34986667 56.5632v-375.01866667a34.11946667 34.11946667 0 0 0-10.00106666-24.1344l-254.64-254.48533333z" p-id="4063" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconFilter',
} as DefineComponent
</script>